import { TESSearchField, TESSearchFields } from '../definitions';

export const ninmtExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];
